import React from 'react';
import { connect } from 'react-redux'
import { usuarioSelector } from '../../selectors/sessionSelector'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle';
import { Row, Col } from 'react-flexbox-grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import './styles.css'

const SeleccionSucursalContainer = ({usuario, handleSucursal}) => {

  return (
    <div>
      <Dialog
        open={true}
        onClose={() => {}}              
        fullWidth={true}
        className='seleccionarSucursal'
      >
        <DialogTitle class='content no-margin title'>
          <div>Elegí la Sucursal</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {usuario?.sucursales.map((item) => 
              <Card className='card' onClick={() => handleSucursal(item)}>
                <CardContent>
                  <Row>
                    <Col md={11}>
                      <div className='smallTextCard'>{item.direccion}</div>
                      <div className='textCard'>{item.nombre.toUpperCase()}</div>
                    </Col>
                    <Col md={1} style={{display: 'flex', alignItems: 'center'}}>
                      <ChevronRightIcon className='iconContraerExpandir' />
                    </Col>
                  </Row>
                </CardContent>
              </Card>
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
  
};


export default SeleccionSucursalContainer;
